import React from 'react'
import {
	Typography,
	IconButton,
	List,
	ListItem,
	ListItemText,
	ListItemAvatar,
	Link,
	Dialog,
	DialogTitle,
	DialogContent,
	useTheme
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import SchoolIcon from '@mui/icons-material/School'

const Institutions = ({ open, onClose, institutions, program }) => {
	const theme = useTheme()

	console.log('popup:', institutions,program)
	const handleClose = () => {
		onClose()
	}

	return open ? (
		<Dialog onClose={handleClose} aria-labelledby='simple-dialog-title' open={open}>
			<DialogTitle id='simple-dialog-title' disableTypography>
				<Typography component='h6' variant='h6' color='textSecondary'>
					{`Institutions where you can study ${program.Title}`}
				</Typography>
				<IconButton
					aria-label='close'
					sx={{ position: 'absolute', right: theme.spacing(1), top: theme.spacing(1), color: theme.palette.grey[500] }}
					onClick={handleClose}
				>
					<CloseIcon />
				</IconButton>
			</DialogTitle>
			<DialogContent dividers>
				<List>
					{institutions.map(({ node }) => (
						<ListItem key={node.id}>
							<ListItemAvatar>
								<SchoolIcon color={theme.palette.text.secondary} />
							</ListItemAvatar>
							<ListItemText
								color={theme.palette.text.secondary}
								primary={node.Title}
								secondary={
									node.Href ? (
										<Link href={node.Href.Url} color='secondary' target='_blank'>
											visit website
										</Link>
									) : null
								}
							/>
						</ListItem>
					))}
				</List>
			</DialogContent>
		</Dialog>
	) : null
}

export default Institutions
